import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import SecuritiesModal from "../../../../modals/yourAssets/BOA/SecuritiesModal";
import { SecondaryButton } from "../../../../common/Buttons";
import FormattedDate from "../../../../utils/TabelDateFormat";
import {
  addUsersS,
  getAllUsersS,
  updateUserS,
} from "../../../../services/yourAssets/SecuritiesServices";
import DeleteDataModal from "../../../../modals/yourAssets/BOA/DeleteDataModal";
import {
  checkIdType,
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../../utils/Utilities";
import toast, { Toaster } from "react-hot-toast";
import SimpleBarReact from "simplebar-react";
import ImportData from "../ImportData";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../constants/constants";
import ModifiedByToaster from "../../../../common/ModifiedByToaster";
import { updateAuditTrails } from "../../../../services/auditTrails";
import { useSelector, useDispatch } from "react-redux";

import {
  getAllUsersBA,
  getFile,
  updateUserBA,
} from "../../../../services/yourAssets/BankBalancesServices";
import FilePreviewModal from "../FilePreviewModal";
import DeleteFileModal from "../../../../modals/yourAssets/BOA/DeleteFileModal";
import { handleReloadFiles } from "../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import {
  deleteUserMediaBOA,
  getUserMediaBOA,
} from "../../../../services/yourAssets/CommonServices";

const Summary = (props) => {
  const dispatch = useDispatch();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const { next } = props;
  const { t, i18n } = useTranslation();
  const [securitiesList, setSecuritiesList] = useState([]);
  const [checkChanges, setCheckChanges] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [newAccountFlag, setNewAccountFlag] = useState(false);
  const [showSecuritiesModal, setShowSecuritiesModal] = useState(false);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [focusedFeild, setFocusedFeild] = useState({});
  const [selectedSubOwner, setSelectedSubOwner] = useState({});
  const [selectedSubOwnerIndex, setSelectedSubOwnerIndex] = useState("");
  const [providerTypeId, setProviderTypeId] = useState("");
  const [continueButton, setContinueButton] = useState(true);
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.securities
  );
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [isDeletingFile, setIsDeletingFile] = useState(false);

  const getAccountList = async () => {
    let result = await getAllUsersS(uID);

    if (result?.success) {
      setApiResponse(result?.payLoad);
      let array = [];

      for (let i = 0; i < result?.payLoad.length; i++) {
        const elementI = result?.payLoad[i];
        let mainObj = {
          id: "",
          providerName: "",
          ownersData: [],
        };
        mainObj.id = elementI?.securityId ? elementI?.securityId : "";
        mainObj.providerName = elementI?.providerName;
        let obj = {
          nameOfOwner: elementI?.nameOfOwner,
          ownerShipPercentage: elementI?.ownerShipPercentage,
          value: elementI?.value,
          dateOfValue: elementI?.dateOfValue,
        };
        mainObj.ownersData.push(obj);
        for (let j = 0; j < elementI?.subSecurities.length; j++) {
          const elementJ = elementI?.subSecurities[j];
          let subObj = {
            nameOfOwner: elementJ?.nameOfOwner,
            ownerShipPercentage: elementJ?.ownerShipPercentage,
            value: elementJ?.value,
            dateOfValue: elementJ?.dateOfValue,
            id: elementJ?.subSecurityId ? elementJ?.subSecurityId : "",
            securityId: elementJ?.securityId ? elementJ?.securityId : "",
            subSecurityId: elementJ?.subSecurityId
              ? elementJ?.subSecurityId
              : "",
          };
          mainObj.ownersData.push(subObj);
        }

        array.push(mainObj);
        setContinueButton(false);
      }
      setSecuritiesList(array);
    }
  };
  useEffect(() => {
    setCheckChanges(false);
    getAccountList();
  }, [checkChanges]);
  const handleUpdates = async (data) => {
    const result = await updateAuditTrails(data, currentConsultantId);
  };
  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[2] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[2]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[2] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[2]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[2] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[2]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, []);

  const handleFinalSubmit = async () => {
    setBtnLoading(true);
    let array = [];
    const securitiesListClone = JSON.parse(JSON.stringify(securitiesList));
    for (let i = 0; i < securitiesListClone.length; i++) {
      const elementI = securitiesListClone[i];
      let mainObj = {
        securityId: elementI?.id?.length > 10 ? elementI.id : "",
        providerName: elementI.providerName,
        nameOfOwner: elementI.ownersData[0]?.nameOfOwner,
        ownerShipPercentage: elementI.ownersData[0]?.ownerShipPercentage,
        value: elementI.ownersData[0]?.value.toString(),
        dateOfValue: elementI.ownersData[0]?.dateOfValue,
        subSecurities: [],
      };

      elementI.ownersData.shift();
      for (let j = 0; j < elementI.ownersData.length; j++) {
        let elementJ = elementI.ownersData[j];
        delete elementJ.id;
      }

      mainObj.subSecurities = elementI.ownersData;

      array.push(mainObj);
    }

    try {
      let result = await updateUserS(array, uID);

      if (result?.success) {
        setCheckChanges(true);
        // toast.success(t(getKeyFromText(result?.message)));
        next();
      } else {
        toast.error(t(getKeyFromText(result?.message)));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSecuritiesModalOpen = () => setShowSecuritiesModal(true);
  const handleSecuritiesModalClose = () => {
    setShowSecuritiesModal(false);
    setNewAccountFlag(false);
    reInitializeSelection();
  };
  const reInitializeSelection = () => {
    setProviderTypeId("");
    setFocusedFeild({});
    setSelectedSubOwner({});
    setSelectedSubOwnerIndex("");
  };
  const handleAddSubOwner = (item, typeId, subOwner, subOwnerIndex) => {
    handleSecuritiesModalOpen();
    setProviderTypeId(typeId);
    setFocusedFeild(item);
    let obj = {
      providerName: item.providerName ? item.providerName : "",
      accountNumber: item.accountNumber ? item.accountNumber : "",
      nameOfOwner: subOwner?.nameOfOwner ? subOwner?.nameOfOwner : "",
      ownerShipPercentage: subOwner?.ownerShipPercentage
        ? subOwner?.ownerShipPercentage
        : "",
      value: subOwner?.value ? subOwner?.value : "",
      dateOfValue: subOwner?.dateOfValue ? subOwner?.dateOfValue : "",
    };
    setSelectedSubOwner(obj);
    setSelectedSubOwnerIndex(subOwnerIndex);
  };
  const handleDeleteSubOwner = (item, typeId, subOwner, subOwnerIndex) => {
    setDeleteDataModal(true);
    setProviderTypeId(typeId);
    setFocusedFeild(item);
    setSelectedSubOwner(subOwner);
    setSelectedSubOwnerIndex(subOwnerIndex);
  };
  const handleAddNewAccount = () => {
    setNewAccountFlag(true);
    handleSecuritiesModalOpen();
  };
  const addNewAccount = (values) => {
    const { providerName, accountNumber, ...subOwnersData } = values;
    let id = securitiesList.length;
    let newAccount = {
      id,
      providerName,
      accountNumber,
      ownersData: [subOwnersData],
    };
    setSecuritiesList((prevList) => [...prevList, newAccount]);
    setNewAccountFlag(false);
    setContinueButton(false);
  };
  const addSubOwnersData = (values, providerTypeId, selectedSubOwnerIndex) => {
    const { providerName, accountNumber, ...subOwnersData } = values;

    let updatedsecuritiesList = securitiesList.map((el) => {
      if (el.id === providerTypeId) {
        el.providerName = providerName;
        el.accountNumber = accountNumber;
        if (selectedSubOwnerIndex || selectedSubOwnerIndex === 0) {
          el.ownersData[selectedSubOwnerIndex] = subOwnersData;
        } else {
          el.ownersData.push(subOwnersData);
        }
      }
      return el;
    });
    setSecuritiesList(updatedsecuritiesList);
    reInitializeSelection();
  };
  const deleteSubOwnersData = (providerTypeId, selectedSubOwnerIndex) => {
    let updatedsecuritiesList;
    if (selectedSubOwnerIndex === 0) {
      updatedsecuritiesList = securitiesList.filter(
        (el) => el.id !== providerTypeId
      );
    } else {
      updatedsecuritiesList = securitiesList.map((el) => {
        if (el.id === providerTypeId) {
          if (selectedSubOwnerIndex || selectedSubOwnerIndex === 0) {
            el.ownersData.splice(selectedSubOwnerIndex, 1);
          }
        }
        return el;
      });
    }
    setSecuritiesList(updatedsecuritiesList);
    handleSecuritiesModalClose();
    reInitializeSelection();
  };
  const totalBankBalance = () => {
    let count = 0;
    securitiesList?.forEach((el) => (count += el?.ownersData[0]?.value));
    return count.toLocaleString("de-DE");
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: uID,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    setIsDeletingFile(true);
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(uID, boaUserMediaFileId);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
      setIsDeletingFile(false);
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);
  return (
    <React.Fragment>
      <Toaster />
      {showSecuritiesModal && (
        <SecuritiesModal
          open={showSecuritiesModal}
          handleOpen={() => handleSecuritiesModalOpen()}
          handleClose={() => handleSecuritiesModalClose()}
          newAccountFlag={newAccountFlag}
          focusedFeild={focusedFeild}
          providerTypeId={providerTypeId}
          selectedSubOwner={selectedSubOwner}
          selectedSubOwnerIndex={selectedSubOwnerIndex}
          addSubOwnersData={addSubOwnersData}
          addNewAccount={addNewAccount}
        />
      )}
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        accountTypeId={providerTypeId}
        selectedSubOwnerIndex={selectedSubOwnerIndex}
        deleteData={deleteSubOwnersData}
        user={focusedFeild.providerName}
      />
      <Box className="securities-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <SecondaryButton
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "1.5rem",
                      marginLeft: "0.5rem",
                      position: "absolute",
                      left: "7px",
                    }}
                  >
                    +
                  </Typography>{" "}
                  {t("add-line")}
                </>
              }
              textTransform="initial"
              fontWeight="normal"
              bgColor="color.magentaLight2"
              borderRadius="40px"
              padding="2px auto"
              minWidth="235px"
              marginLeft="20px"
              border="none"
              hoverBgColor="color.magentaLight1"
              click={() => handleAddNewAccount()}
            />
            <ImportData
              sectionId={3}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          {/* <SimpleBarReact
        style={{ maxHeight: 300, marginTop: "2rem" }}
        autoHide={false}
      > */}
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{ "th , td": { border: "none" } }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("s-table-heading-1")} </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-3")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-4")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {securitiesList.map((item, index) => (
                  <React.Fragment key={item.id}>
                    {item.ownersData?.length > 0 ? (
                      item.ownersData.map((subOwner, subOwnerIndex, arr) => (
                        <TableRow
                          sx={{
                            backgroundColor: `${
                              index % 2 === 0
                                ? "color.smokeWhite"
                                : "color.white"
                            }`,
                          }}
                          key={subOwnerIndex}
                          className={
                            updatedIds.includes(item.id) ||
                            updatedIds.includes(subOwner?.id)
                              ? "highlighted-table-row"
                              : ""
                          }
                        >
                          <TableCell>
                            {subOwnerIndex === 0 ? item.providerName : null}
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "2px 8px",
                              }}
                            >
                              <Box>{`${
                                subOwner?.nameOfOwner
                                  ? subOwner.nameOfOwner
                                  : "-"
                              }`}</Box>
                              {subOwnerIndex === 0 ? (
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="Add"
                                  size="small"
                                  onClick={() =>
                                    handleAddSubOwner(item, item.id)
                                  }
                                >
                                  <AddCircleOutlineSharpIcon />
                                </IconButton>
                              ) : null}
                            </Box>
                          </TableCell>
                          <TableCell>{`${
                            subOwner?.ownerShipPercentage
                              ? subOwner.ownerShipPercentage + "%"
                              : "-"
                          }`}</TableCell>

                          <TableCell>
                            {/* {`${
                            subOwner?.dateOfValue
                              ? subOwner.dateOfValue
                                  .slice(0, 10)
                                  .split("-")
                                  .reverse()
                                  .join("-")
                              : "-"
                          }`} */}
                            <FormattedDate
                              date={subOwner.dateOfValue}
                              language={i18n.language}
                            />
                          </TableCell>
                          <TableCell>{`${
                            subOwner?.value
                              ? Number(subOwner.value).toLocaleString("de-DE") +
                                " €"
                              : "-"
                          }`}</TableCell>

                          <TableCell>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="add"
                              size="small"
                              onClick={() =>
                                handleAddSubOwner(
                                  item,
                                  item.id,
                                  subOwner,
                                  subOwnerIndex
                                )
                              }
                            >
                              <img
                                src="/assets/icons/edit-icon.svg"
                                alt="edit"
                              />
                            </IconButton>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="delete"
                              size="small"
                              onClick={() =>
                                handleDeleteSubOwner(
                                  item,
                                  item.id,
                                  subOwner,
                                  subOwnerIndex
                                )
                              }
                            >
                              <img
                                src="/assets/icons/delete-icon.svg"
                                alt="delete"
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow
                        sx={{
                          backgroundColor: `${
                            index % 2 === 0 ? "color.smokeWhite" : "color.white"
                          }`,
                        }}
                      >
                        <TableCell>{item.providerName}</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell align="right">
                          <IconButton
                            sx={{ cursor: "pointer" }}
                            aria-label="add"
                            size="small"
                            onClick={() => handleAddSubOwner(item, item.id)}
                          >
                            <img src="/assets/icons/edit-icon.svg" alt="edit" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}

                <TableRow sx={{ background: "#dfc8db" }}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">{t("total")}</TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                  >{` ${totalBankBalance()} € `}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* </SimpleBarReact> */}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleFinalSubmit}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
